import VBtnToggle from './VBtnToggle';
export { VBtnToggle };
export default VBtnToggle;
//# sourceMappingURL=index.js.map